import { A as p } from "./index-isgVnOkQ.mjs";
import { h as g } from "./index-Dj1VNACs.mjs";
import { useState as f, useEffect as h } from "react";
const s = {}, m = {};
function u(e) {
  const [r, c] = f(() => {
    const n = m[e];
    return n ? { props: n, url: e } : void 0;
  });
  return h(() => {
    if ((r == null ? void 0 : r.url) === e)
      return;
    const n = (t) => {
      const o = {
        dangerouslySetInnerHTML: { __html: t.innerHTML },
        viewBox: t.getAttribute("viewBox") ?? void 0,
        xmlns: t.getAttribute("xmlns") ?? void 0
      };
      m[e] = o, c({ props: o, url: e });
    }, i = (t) => {
      const o = typeof t == "string" ? t : t.message;
      g.handleError(typeof o == "string" ? o : `Unknown error getting SVG at "${e}"`), c({ props: void 0, url: e });
    };
    if (e in s) {
      s[e].then(n).catch(i);
      return;
    }
    const a = p.createCancelSource();
    return s[e] = p.get(e, { cancelToken: a }).then(({ data: t }) => {
      const { documentElement: o } = new DOMParser().parseFromString(t, "image/svg+xml");
      if (o.querySelector("parsererror"))
        throw Error(`Failed to parse SVG at "${e}"`);
      return n(o), o;
    }).catch(i), () => {
      a.cancel();
    };
  }, [e, r]), r == null ? void 0 : r.props;
}
export {
  u
};
//# sourceMappingURL=use-svg-DBlH3_L4.mjs.map
